import { put, takeLeading } from 'redux-saga/effects';

import { apiErrorHandler } from 'utils';

import discoverCategoryApi from 'api/discoverCategory';
import { GET_DISCOVERY_CATEGORIES, GET_DISCOVERY_CATEGORY_DETAILS } from './actionTypes';
import {
  actionGetDiscoveryCategoryDetailsFailed,
  actionGetDiscoveryCategoryDetailsSuccess,
  actionGetDiscoveryCategoriesFailed,
  actionGetDiscoveryCategoriesSuccess,
} from './actions';

function* getDiscoveryCategories({ payload }) {
  try {
    const r = yield discoverCategoryApi.getDiscoverCategories(payload);
    yield put(actionGetDiscoveryCategoriesSuccess(r.payload));
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionGetDiscoveryCategoriesFailed());
  }
}

function* getDiscoveryCategoryDetails({ payload }) {
  try {
    const r = yield discoverCategoryApi.getDiscoverCategoryDetails(payload);
    yield put(actionGetDiscoveryCategoryDetailsSuccess(r.payload));
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionGetDiscoveryCategoryDetailsFailed());
  }
}

export default function* discoverCategory() {
  yield takeLeading(GET_DISCOVERY_CATEGORIES, getDiscoveryCategories);
  yield takeLeading(GET_DISCOVERY_CATEGORY_DETAILS, getDiscoveryCategoryDetails);
}
